import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ExperienceRibbon } from '../components/ExperienceRibbon';
import { CulinaryGrid } from '../components/CulinaryGrid';
import { StorySection } from '../components/StorySection';
import { SocialTicker } from '../components/SocialTicker';
interface HomeProps {
  onNavigate: (page: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <main data-id="element-345">
      <HeroSection data-id="element-346" />
      <ExperienceRibbon onNavigate={onNavigate} data-id="element-347" />
      <CulinaryGrid data-id="element-348" />
      <StorySection data-id="element-349" />
      <SocialTicker data-id="element-350" />
    </main>;
}